import { FeatureBento } from "@/components/marketing/FeatureBento";

export const Features = () => {
  return (
    <section id="features" className="py-20 md:py-28 bg-background">
      <div className="container px-4">
        <div className="max-w-3xl mb-12 md:mb-16">
          <span className="text-[11px] font-mono uppercase tracking-widest text-muted-foreground">
            Features
          </span>
          <h2 className="text-3xl sm:text-4xl md:text-5xl font-display font-bold mt-3 mb-5">
            Simple tools. Powerful results.
          </h2>
          <p className="text-base md:text-lg text-muted-foreground">
            You don't need a full CRM. You need these features — and nothing else.
          </p>
        </div>

        <FeatureBento />
      </div>
    </section>
  );
};
